import type { StaffMemberAvailability } from "services/types/staff-availability.type";
import {
  convertDateInTimezoneToCurrent,
  formatStaffMemberFullName,
} from "./common";
import { formatClinic } from "./clinics.util";

export function formatStaffAvailability(
  staffAvailability: StaffMemberAvailability
) {
  const timeZone = staffAvailability.clinic?.timezone;
  return {
    ...staffAvailability,
    start_moment: convertDateInTimezoneToCurrent(
      staffAvailability.start_moment,
      timeZone
    ).toISOString(),
    end_moment: convertDateInTimezoneToCurrent(
      staffAvailability.end_moment,
      timeZone
    ).toISOString(),
    staff_member: formatStaffMemberFullName(staffAvailability.staff_member),
    clinic: formatClinic(staffAvailability.clinic),
  };
}
